import { computed } from 'vue';

import { propsFactory } from '@components/utils';

import type { PropType, ComputedRef } from 'vue';

export interface ITextProps {
  text: string | number | undefined;
}
export interface IUseText {
  hasText: ComputedRef<boolean>;
}

export const makeTextProps = propsFactory(
  {
    /**
     * Текст
     */
    text: {
      type: [String, Number] as PropType<string | number>,
      default: undefined
    }
  },
  'text'
);

export function useText(props: ITextProps, slots: Record<string, unknown>): IUseText {
  const hasText = computed(() => {
    return !!props.text || !!slots.text || !!slots.default;
  });

  return { hasText };
}
